import Component from '../Component';
import React from 'react';
import DbInfo from '../../dbinfo';
import immutable from 'immutable';
import Checkbox from './IconCheckbox';

export default class MultiCheckbox extends Component {

	handleClick(val, item) {
		let value;
		if (!this.props.value) {
			value = [];
		}
		else {
			value = this.props.value.toJS ? this.props.value.toJS() : this.props.value;
		}
		if (val) {
			value.push(item.id);
		}
		else {
			const i = value.indexOf(item.id);
			value.splice(i, 1);
		}
		if (this.props.onChange) {
			this.props.onChange(immutable.List(value));
		}
	}

	render() {
		const items = this.props.options.asArray().map((item) => {
			const value = this.props.value && this.props.value.indexOf(item.id) != -1;
			return <label key={item.id} >
					<Checkbox onChange={(val) => this.handleClick(val, item)} value={value} />
					<span onClick={() => this.handleClick(!value, item)} className="multi-checkbox-label">{item.title}</span>
				</label>
		});

		return (
			<span className="multi-checkbox">{items}</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/MultiCheckbox.js